import React from "react";

const RunningBanner = () => {
  return (
    <div className="banner-track">
      <div className="banner-marquee single">
        <span className="runner-emoji">🏃‍♂️</span>
        <span className="runner-emoji">🏃‍♂️</span>
        <div className="banner-flag">
          <span>Snälla boka oss!</span>
        </div>
      </div>
    </div>
  );
};

export default RunningBanner;
